<template>

    <div style="min-height: 100vh; min-width: 100vw; background-color: rgb(255, 255, 255);">
    <div class="invoice-box">
    <!-- <TemplateBasic> -->

      <div v-show="formID">
        <h3 class="d-flex justify-content-center">RETURN PASSCARD APPLICATION FORM</h3>
        <br>
        <table>
          <tr>
            <td>Form ID :</td>
            <td class="font-weight-bold">{{ this.formID }}</td>
          </tr>
          <tr>
            <td>Car Park Name :</td>
            <td class="font-weight-bold">{{ this.carparkName }}</td>
          </tr>
          <tr>
            <td>Car Park Product Name :</td>
            <td class="font-weight-bold">{{ this.carparkProduct }}</td>
          </tr>
          <tr>
            <td>Account No. :</td>
            <td class="font-weight-bold">{{ this.accountNo }}</td>
          </tr>
          <tr>
            <td>Account Holder Name :</td>
            <td class="font-weight-bold">{{ this.accountHolderName }}</td>
          </tr>
          <tr>
            <td>Submission Date :</td>
            <td class="font-weight-bold">{{ this.submissionDate }}</td>
          </tr>
          <tr>
            <td>Parker and Passcard Status :</td>
            <td class="font-weight-bold">{{ this.parkerAndPasscardStatus }}</td>
          </tr>
        </table>

        <br>

        <table class="table table-bordered">
          <tr>
            <th>Parker Name</th>
            <th>Inventory Passcard</th>
            <th>Passcard Type</th>
            <th>Passcard No.</th>
            <th>Passcard Condition</th>
          </tr>
          <tr>
            <td>{{ parkerName }}</td>
            <td>{{ passcard }}</td>
            <td>{{ passcardType }}</td>
            <td>{{ passcardNo }}</td>
            <td>{{ passcardCondition }}</td>
          </tr>
        </table>

        <br>

        <h3>STAFF INPUT INFORMATION</h3>
        
        <table>
          <tr>
            <td>Staff Name :</td>
            <td class="font-weight-bold">{{ this.staffName }}</td>
          </tr>
          <tr>
            <td>Staff No :</td>
            <td class="font-weight-bold">{{ this.staffNo }}</td>
          </tr>
        </table>

        <br>

        <h3>Refund Method</h3>
        
        <table>
          <tr>
            <td>Bank Name :</td>
            <td class="font-weight-bold">{{ this.refundBankName }}</td>
          </tr>
          <tr>
            <td>Bank Account Holder Name :</td>
            <td class="font-weight-bold">{{ this.refundBankAccountHolderName }}</td>
          </tr>
          <tr>
            <td>Bank Account No. :</td>
            <td class="font-weight-bold">{{ this.refundBankAccountNo }}</td>
          </tr>
          <tr>
            <td>Bank Account Type :</td>
            <td class="font-weight-bold">{{ this.refundBankAccountType }}</td>
          </tr>
          <tr>
            <td>GIRO Notification Email :</td>
            <td class="font-weight-bold">{{ this.refundGiroNotificationEmail }}</td>
          </tr>
          <tr>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td class="font-weight-bold">GIRO Verification Method</td>
            <td></td>
          </tr>
          <tr>
            <td>Business Registration No. :</td>
            <td class="font-weight-bold">{{ this.refundBusinessRegistraionNo }}</td>
          </tr>
        </table>

        <br>
        <hr>
        <br>
        <img v-bind:src="imageHeader" style="width: 100%"/>
        <br>
        <br>

        <h3 class="d-flex justify-content-center">PASSCARD RETURN ACKNOWLEDGEMENT</h3>
        <br>
        <div>
          This is to confirm that the parking access card no {{ this.passcardNo }}
          <br>
          belong to {{accountHolderName}} ({{accountNo}} - {{carparkName}})
          <br>
          <br>
          
          <table>
            <tr>
              <td>Has Been Received By:</td>
            </tr>
            <tr>
              <td>Staff Name :</td>
              <td class="font-weight-bold">{{ this.staffName }}</td>
            </tr>
            <tr>
              <td>Staff No :</td>
              <td class="font-weight-bold">{{ this.staffNo }}</td>
            </tr>
            <tr>
              <td>Submission Date :</td>
              <td class="font-weight-bold">{{ this.submissionDate }}</td>
            </tr>
            <tr>
              <td>Form ID :</td>
              <td class="font-weight-bold">{{ this.formID }}</td>
            </tr>
          </table>
        </div>

      </div>

      <TemplateFeedback ref="pageFeedback" />

    <!-- </TemplateBasic> -->
    </div>
    </div>

</template>

<style scoped>
  .bordered-table1 {
  border: 1px solid #d3d3d3;
  border-collapse: collapse;
  line-height: 1.5;
  padding: 5px
  }
  .red {
  color: red;
  }
  .bordered-table1.bold {
  font-weight: bold;
  }
  .bordered-table1.right {
  text-align: right;
  }

  .invoice-box{ max-width:800px; margin:auto; padding:30px; border:1px solid #eee; box-shadow:0 0 10px rgba(0, 0, 0, .15); font-size:16px; line-height:24px; font-family:"Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif; color:#555; } 
  /* .invoice-box table{ width:100%; line-height:inherit; text-align:left; } 
  .invoice-box table tr.heading2 td{font-weight:bold;} 
  .invoice-box table tr.heading3 td{font-size:10px} 
  .invoice-box table td{ padding:5px; vertical-align:top; }
  .invoice-box table tr td:nth-child(2){ text-align:right; }
  .invoice-box table tr td:nth-child(3){ text-align:right; } 
  .invoice-box table tr.top table td{ padding-bottom:20px; } 
  .invoice-box table tr.top table td.title{ font-size:45px; line-height:45px; color:#333; } 
  .invoice-box table tr.information table td{ padding-bottom:40px; } 
  .invoice-box table tr.heading td{ background:#eee; border-bottom:1px solid #ddd; font-weight:bold; } 
  .invoice-box table tr.details td{ padding-bottom:20px; } 
  .invoice-box table tr.item td{ border-bottom:1px solid #eee; } 
  .invoice-box table tr.item.last td{ border-bottom:none; } 
  .invoice-box table tr.total-pay td:nth-child(3){ border-top:2px solid #eee; font-weight:bold; } 
  .invoice-box table tr.total-pay td:nth-child(3){ border-top:1px solid #eee; font-weight:bold; } 
  .invoice-box table tr.top table td{ width:100%; display:block; text-align:center; } 
  .invoice-box table tr.information table td{ width:100%; display:block; text-align:center; }  */
</style>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppForm from "@/components/App/AppForm";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

export default {
  name: "PagePasscardTerminationApplicationPrint",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppForm,
    AppModalForm,
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Passcard' },
        { name: 'Termination Passcard Return' },
        { name: 'Application' },
      ],

      pageStaff: null,
      pageCarpark: null,
      pageZone: null,
      pagePasstype: null,
      pagePasscard: null,
      pageCustomer: null,
      pageTermination: null,
      pagePasscardReturn: null,
      pageLease: null,
      pageSeason: null,
      pageFees: {},
      pageParker: null,

      showTerminationApplication: false,

      formID: null,
      carparkName: null,
      carparkProduct: null,
      accountNo: null,
      accountHolderName: null,
      submissionDate: null,
      parkerAndPasscardStatus: null,

      parkerName: null,
      passcard: null,
      passcardType: null,
      passcardNo: null,
      passcardCondition: null,

      staffName: null,
      staffNo: null,

      refundBankName: null,
      refundBankAccountHolderName: null,
      refundBankAccountNo: null,
      refundBankAccountType: null,
      refundGiroNotificationEmail: null,
      refundBusinessRegistraionNo: null,

      imageHeader: '',
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$nextTick(() => {
      helper.setSidebar('/passcardTerminationApplication');
    });

    this.loadApplication();
  },
  methods: {
    loadApplication() {
      let terminationPasscardReturnID = this.$route.query.terminationPasscardReturnID;
      if(!terminationPasscardReturnID) {
        this.$refs['pageFeedback'].setFeedbackError('Invalid Termination Passcard Return Application');
        return;
      }

      let feedbackItem = 'passcard return application';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.API_URL + '/api2/licensePasscardReturn/' + terminationPasscardReturnID,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pagePasscardReturn = response.data[0];

          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadPasscardReturnApplicationData(response.data[0].applicationData);
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadPasscardReturnApplicationData(applicationData) {
      let feedbackItem = 'passcard return application data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/applicationData/' + applicationData,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pagePasscardReturn = Object.assign(response.data, this.pagePasscardReturn);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.loadStaff();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadStaff() {
      let feedbackItem = 'staff data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/personnel/' + this.pagePasscardReturn['staffID'],
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageStaff = response.data[0];
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadLicense();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading ' + feedbackItem);
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadLicense() {
      let feedbackItem = 'license data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/licenses/' + this.pagePasscardReturn['licenseID'],
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageLicense = response.data[0];
            this.loadCarpark();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading ' + feedbackItem);
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCarpark() {
      let feedbackItem = 'car park data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.pageLicense.carparkID,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageCarpark = response.data[0];
            this.loadCarparkFinance();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading ' + feedbackItem);
          }
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCarparkFinance() {
      let feedbackItem = 'car park detail';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.pageLicense.carparkID + '/finance/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageFinance = response.data[0];
            this.imageHeader = this.pageFinance.logoHeader1;
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadCustomer();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadCustomer() {
      let feedbackItem = 'customer data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/' + this.pageLicense.customerID,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageCustomer = response.data[0];
            this.loadLease();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading ' + feedbackItem);
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadLease() {
      let feedbackItem = 'lease data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/licenses/' + this.pageLicense.id + '/leases/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('');

          this.pageLease = response.data.find(k => k.applicationNum === this.pagePasscardReturn.applicationNum);
          if(this.pageLease) {
            for(let lease of response.data) {
              if(lease['leaseNum'] === this.pageLease['leaseNum']) {
                if(lease['passcardID'] > 0) {
                  if(this.pageLease['passcardID'] > 0) {
                    if(this.pageLease['passcardDate'] < lease['createDate']) {
                      this.pageLease['passcardID'] = lease['passcardID'];
                      this.pageLease['passcardDate'] = lease['createDate'];
                    }
                  } else {
                    this.pageLease['passcardID'] = lease['passcardID'];
                    this.pageLease['passcardDate'] = lease['createDate'];
                  }
                }
              } 
            }
            this.loadSeason();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading ' + feedbackItem);
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadSeason() {
      let feedbackItem = 'product data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/season/' + this.pageLease.seasonID,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageSeason = response.data[0];
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadParker();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading ' + feedbackItem);
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadParker() {
      let feedbackItem = 'parker data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/subscriber/' + this.pageLease.parkerID,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageParker = response.data[0];
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadPasscard();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading ' + feedbackItem);
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadPasscard() {
      let feedbackItem = 'passcard data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/passcard/' + this.pageLease.passcardID,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pagePasscard = response.data[0];
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadPasscardType();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading ' + feedbackItem);
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadPasscardType() {
      let feedbackItem = 'passcard type data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/passtype/' + this.pagePasscard.passtypeID,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pagePasscardType = response.data[0];
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadEverything();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading ' + feedbackItem);
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadEverything() {
      this.formID = helper.plFormPLPRNum(this.pagePasscardReturn.applicationNum, this.pageCarpark.id);
      this.carparkName = this.pageCarpark.name;
      this.carparkProduct = this.pageSeason.name;
      this.accountNo = helper.plFormPLNum(this.pageLicense.licenseOperatorNum, this.pageCarpark.carparkID);
      this.accountHolderName = this.pageCustomer.name;
      this.submissionDate = helper.formatDate(this.pagePasscardReturn.createDate);
      this.parkerAndPasscardStatus = '';

      this.parkerName = this.pageParker.name;
      this.passcard = 'Yes';
      this.passcardType = this.pagePasscardType.name;
      this.passcardNo = this.pagePasscard.sku;
      this.passcardCondition = this.pagePasscardReturn.conditions;

      this.refundBankName = '';
      this.refundBankAccountHolderName = '';
      this.refundBankAccountNo = '';
      this.refundBankAccountType = '';
      this.refundGiroNotificationEmail = '';
      this.refundBusinessRegistraionNo = '';

      this.staffName = this.pageStaff.name;
      this.staffNo = this.pageStaff.id;

    },


    loadZone() {
      let feedbackItem = 'zone data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/zone/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageZone = response.data;
          this.loadCustomer();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadTerminationApplication() {
      let feedbackItem = 'termination license';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/licenses/' + this.$refs['licenseFilter'].filterValue + '/licenseTerminate',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageTermination = response.data;

          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadPasscardReturnApplication();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadPasscardReturnApplication() {
      let feedbackItem = 'passcard return application';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/licenses/' + this.$refs['licenseFilter'].filterValue + '/licensePasscardReturn/' + this.$route.query.passcardReturnID,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pagePasscardReturn = response.data;

          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadPasscardReturnApplicationData(response.data[0].applicationData);
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadLeaseData() {
      if(!this.pageSeason) {
        this.loadSeason();
        return;
      }

      if(!this.pageParker) {
        this.loadParker();
        return;
      }

      if(this.checkSeasonFees()) {
        return;
      }

      this.$refs['pageFormApplication'].setForm();
      this.pageLease.forEach(k => {
        k['_license'] = this.$refs['licenseFilter'].filterData.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue));
        k['_licenseID'] = k['_license']['id'];
        k['_licenseNum'] = k['_license']['licenseOperatorNum'];
        k['_carparkNum'] = k['_license']['carparkID'];

        k['_customer'] = this.pageCustomer.find(j => j.id === k['_license']['customerID']);
        k['_carpark'] = this.pageCarpark.find(j => j.id === k['_license']['carparkID']);
        k['_carparkName'] = (k['_carpark'] || {}).name;

        k['_product'] = this.pageSeason.find(j => j.id === k['seasonID']);
        k['_productName'] = (k['_product'] || {}).name;
        k['_parker'] = this.pageParker.find(j => j.id === k['parkerID']);
        k['_parkerInformation'] = helper.plFormParker(k['_parker']);

        k['_zone'] = this.pageZone.find(j => j.id === (k['_product'] || {})['zoneID']);
        k['_zoneName'] = (k['_zone'] || {}).name;

        if(k['passcardID']) {
          k['_passcard'] = this.pagePasscard.find(j => helper.compareID(j.id, k['passcardID']));
        }

        k['_termination'] = this.pageTermination.find(j => j['applicationNum'] === k['terminateNum']);

        k['_parkingFees'] = this.pageFees[k['seasonID']];
        switch(parseInt(k['paymentPlan'])) {
          case 1:
            k['_parkingFeesText'] = helper.formatMoney(k['_parkingFees']['monthly']) + ' / month';
            break;
          case 2:
            k['_parkingFeesText'] = helper.formatMoney(k['_parkingFees']['quarterly']) + ' / quarter';
            break;
          case 3:
            k['_parkingFeesText'] = helper.formatMoney(k['_parkingFees']['halfYearly']) + ' / half-year';
            break;
          case 4:
            k['_parkingFeesText'] = helper.formatMoney(k['_parkingFees']['annually']) + ' / annual';
            break;
        }
      });

      this.$refs['passcardFilter'].setFilterData(this.pageLease);
      this.$refs['passcardFilter'].filterValue = this.pageLease[0].id;
      this.onFilterPasscardChange();
      // this.$refs['pageTable'].setTableData(this.pageLease);

      // if(window.location.href.includes('localhost')) {
      //   this.$refs['passcardFilter'].filterValue = 30;
      //   this.$refs['pageFormApplication'].formData['conditions'] = 'Good';
      //   this.$refs['pageFormApplication'].formData['staffID'] = 7;
      //   this.$refs['pageFormApplication'].formData['staffNo'] = 7;
      //   this.onFilterPasscardChange();
      // }
    },
    loadSeasonFees(seasonID) {
      this.pageFees[seasonID] = null;

      let feedbackItem = 'product fees data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/season/' + seasonID + '/currentSeasonFees/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            if(this.pageFees[seasonID] = response.data[0]) {
              this.$refs['pageFeedback'].setFeedbackMessage();
              this.loadLeaseData();
            } else {
              this.$refs['pageFeedback'].setFeedbackError('No active ' + feedbackItem + ' available.');
            }
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    showLeaseData() {
      this.showTerminationApplication = true;
      let temp = this.pageLease.filter(k => helper.compareID(k.id ,this.$refs['passcardFilter'].filterValue));
      this.$refs['pageTable'].setTableData(temp);
    },
    checkSeasonFees() {
      for(let leaseData of this.pageLease) {
        if(leaseData['seasonID'] && this.pageFees[leaseData['seasonID']] === undefined) {
          this.loadSeasonFees(leaseData['seasonID']);
          return true;
        }
      };
    },

    onFilterCarparkChange(dataIndex) {
      this.showTerminationApplication = false;
      this.$refs['pageTable'].setTableData(this.pageLease = null);
      this.$refs['passcardFilter'].setFilterData(null);
      this.loadLicense();
    },
    onFilterLicenseChange(dataIndex) {
      this.showTerminationApplication = false;
      this.$refs['pageTable'].setTableData(this.pageLease = null);
      this.$refs['passcardFilter'].setFilterData(null);
      this.pageSeason = null;
      this.pageParker = null;
      this.loadTerminationApplication();
    },
    onFilterPasscardChange() {
      this.showLeaseData();
    },

    onTableDataClick(tableData, tableDataIndex) {
      this.$refs['pageFeedback'].setFeedbackMessage();
      this.$refs['pageModal'].setModalOpen(false, 'Issue Passcard', tableData[tableDataIndex]);
    },
    onFormInput(formData, formParameter, input) {
      if(formParameter.key === 'staffID') {
        let staff = helper.inputSelectFindOption(this.APPLICATION_PARAM_MAP['staffID'], formData['staffID']) || {}
        formData['staffNo'] = staff['personnelCode'];
      }
    },

    async onIssuePasscardClick() {
      let formData = this.$refs['pageModal'].$refs['modalForm'].formData;
      // return;

      let temp = {};
      temp['movements'] = 'Issued';

      let feedbackItem = 'passcard status';
      this.$refs['pageModal'].setModalLoading('Setting ' + feedbackItem);
      // TODO kw1 update passcard status
      let result = true;
      // let result = await this.$http
      //   .put(
      //     helper.SERVER_URL + '/api2/passcard/' + formData['passcardID'],
      //     querystring.stringify(temp),
      //     helper.createAxiosFormConfig()
      //   )
      //   .then(response => {
      //     return true;
      //   })
      //   .catch(error => {
      //     this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'setting', feedbackItem));
      //   });

      if(result) {
        temp = {};
        temp['passcardID'] = formData['passcardID'];

        feedbackItem = 'lease passcard status';
        this.$refs['pageModal'].setModalLoading('Setting ' + feedbackItem);
        this.$http
          .put(
            helper.SERVER_URL + '/api2/leases/' + formData['id'],
            querystring.stringify(temp),
            helper.createAxiosFormConfig()
          )
          .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
            this.$refs['pageModal'].setModalClose();
            this.$refs['pageTable'].setTableData(this.pageLease = null);
            this.loadPasscard();
          })
          .catch(error => {
            this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'setting', feedbackItem));
          });
      }
    },

    onSubmitButtonClick() {
      if(!this.$refs['pageFormApplication'].validateForm()) {
        this.addApplicationData({});
      }
    },

    addApplicationData(data) {
      let feedbackItem = 'passcard return appplication data';
      this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + feedbackItem);
      this.$http
        .put(
          helper.SERVER_URL + '/api2/applicationData/',
          querystring.stringify({application: ''}),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('Successfully added ' + feedbackItem);
          data['applicationDataID'] = response.data;
          this.addApplication(data);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', feedbackItem));
        })
    },
    addApplication(data) {
      let tempData = {};
      tempData['applicationData'] = data['applicationDataID'];
      tempData['licenseID'] = this.$refs['licenseFilter'].filterValue;
      tempData['leases'] = [].concat(this.pageLease.find(k => helper.compareID(k.id, this.$refs['passcardFilter'].filterValue)));
      tempData['leases'] = JSON.stringify(tempData['leases']);
      
      let feedbackItem = 'passcard return appplication';
      this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + feedbackItem);
      this.$http
        .post(
          helper.API_URL + '/api2/licensePasscardReturn/',
          querystring.stringify(tempData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.approveApplication(response.data);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', feedbackItem));
        })
    },
    approveApplication(data) {
      let feedbackItem = 'passcard return appplication';
      this.$refs['pageFeedback'].setFeedbackLoading('Approving ' + feedbackItem);
      this.$http
        .post(
          helper.API_URL + '/api2/licensePasscardReturn/' + data[0].id + '/approve',
          querystring.stringify(null),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.updatePasscardMovement();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'approving', feedbackItem));
        })
    },
    updatePasscardMovement() {
      let lease = this.pageLease.find(k => helper.compareID(k.id, this.$refs['passcardFilter'].filterValue));
      let passcard = this.pagePasscard.find(j => helper.compareID(j.id, lease['passcardID']));
      
      passcard['movement'] = 'Returned';
      passcard['carparkID'] = this.pageLicense.carparkID;

      let feedbackItem = 'passcard movement';
      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + feedbackItem);
      this.$http
        .post(
          helper.SERVER_URL + '/api2/passcard/' + lease.passcardID,
          querystring.stringify(passcard),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          // TODO kw1 go to passcard termination list
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', feedbackItem));
        })
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Passcard/PagePasscard_TerminationApplicationPrint.vue